import { Directive, HostBinding } from '@angular/core';

@Directive({
  // eslint-disable-next-line
  selector: 'mm-expansion-title',
})
export class MmExpansionTitleDirective {
  @HostBinding('class.mm-expansion-header__title')
  wrapper = true;
}
